import {
  ADD_BACKGROUND,
  ADD_BACKGROUND_FAILURE,
  ADD_BACKGROUND_SUCCESS,
  DELETE_BACKGROUND,
  DELETE_BACKGROUND_FAILURE,
  DELETE_BACKGROUND_SUCCESS,
  DELETE_INTERVIEWS,
  DELETE_INTERVIEWS_FAILURE,
  DELETE_INTERVIEWS_SUCCESS,
  GET_BACKGROUND_LISTING,
  GET_BACKGROUND_LISTING_FAILURE,
  GET_BACKGROUND_LISTING_SUCCESS,
  GET_INTERVIEWS_LISTING,
  GET_INTERVIEWS_LISTING_FAILURE,
  GET_INTERVIEWS_LISTING_SUCCESS,
  TOGGLE_INTERVIEW_TAB,
} from "../constants";

const initialState = {
  isLoading: false,
  locations: [],
  interviews: [],
  count: 0,
  deleted: 0,
  interview: {},
  error: null,
  activeTab: "interviews",
  backgrounds: [],
  loadingBackgrounds: false,
  total: 0,
};

export default function InterviewsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_INTERVIEWS_LISTING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_INTERVIEWS_LISTING_SUCCESS:
      console.log("action.payload", action.payload);
      return {
        ...state,
        isLoading: false,
        count: action.payload.paginate?.total,
        interviews: action.payload.data,
        deleted: action.payload.deleted,
      };
    case GET_INTERVIEWS_LISTING_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case DELETE_INTERVIEWS:
    case DELETE_INTERVIEWS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case DELETE_INTERVIEWS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case TOGGLE_INTERVIEW_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };

    case GET_BACKGROUND_LISTING:
      return {
        ...state,
        loadingBackgrounds: true,
        error: null,
      };

    case GET_BACKGROUND_LISTING_SUCCESS:
      return {
        ...state,
        loadingBackgrounds: false,
        backgrounds: action.payload.records,
        total: action.payload.total,
        currentPage: action.payload.current_page,
      };

    case GET_BACKGROUND_LISTING_FAILURE:
      return {
        ...state,
        loadingBackgrounds: false,
        error: action.payload,
      };

    case ADD_BACKGROUND:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ADD_BACKGROUND_SUCCESS:
      return {
        ...state,
        isLoading: false,
        // backgrounds: [action.payload, ...state.backgrounds],
      };

    case ADD_BACKGROUND_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case DELETE_BACKGROUND:
      return {
        ...state,
        loadingBackgrounds: true,
        error: null,
      };

    case DELETE_BACKGROUND_SUCCESS:
      return {
        ...state,
        loadingBackgrounds: false,
        backgrounds: state.backgrounds.filter(
          (b) => b.id !== action.payload.id,
        ),
      };

    case DELETE_BACKGROUND_FAILURE:
      return {
        ...state,
        loadingBackgrounds: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
